import styled, { css } from 'styled-components';

const RADIO_SIZE = 20;

function adjustRadioSize({ pixelRatio }: { pixelRatio: number }) {
  const renderSize = pixelRatio * RADIO_SIZE;
  const closestSize = Math.round(renderSize / 2) * 2;
  const precision = 10000000000000;
  const adjustedSize = Math.round((closestSize / pixelRatio) * precision) / precision;

  return css`
    width: ${adjustedSize}px;
    height: ${adjustedSize}px;
  `;
}

function adjustBulletSize({ pixelRatio }: { pixelRatio: number }) {
  const renderSize = pixelRatio * 10;
  const closestSize = Math.ceil(renderSize / 2) * 2;
  const precision = 10000000000000;
  const adjustedSize = Math.round((closestSize / pixelRatio) * precision) / precision;
  const adjustedPosition = adjustedSize / 2;

  return css`
    width: ${adjustedSize}px;
    height: ${adjustedSize}px;
    margin-top: -${adjustedPosition}px;
    margin-left: -${adjustedPosition}px;
  `;
}

export const StyledBullet = styled.span<{needsRadioAdjustment?: boolean; needsBulletAdjustment?: boolean; pixelRatio?: number}>`
  display: inline-block;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme?.RadioButton?.borderColor || theme.colors.gray5};
  line-height: 1;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  position: relative;

  ${({ needsRadioAdjustment, pixelRatio }) => needsRadioAdjustment && adjustRadioSize({ pixelRatio })}

  ${({ needsRadioAdjustment }) => !needsRadioAdjustment && css`
    width: ${RADIO_SIZE}px;
    height: ${RADIO_SIZE}px;
  `}

  input:checked:not(:disabled):not([disabled]) ~ & {
    border-color: ${({ theme }) => theme?.RadioButton?.checkedBorderColor || theme?.RadioButton?.checkedColor || theme.colors.light};
  }

  input:focus ~ & {
    box-shadow: ${({ theme }) => theme.colors.focus} 0 0 3px 2px;
  }

  input:focus:not(:focus-visible) ~ & {
    box-shadow: none;
  }

  input:disabled ~ &, input[disabled] ~ & {
    border-color: ${({ theme }) => theme.colors.shadowGray1};
    background: ${({ theme }) => theme?.RadioButton?.disabledBackground};
  }

  &::after {
    content: '';
    display: none;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;

    input:checked ~ & { 
      display: block;
    }

    ${({ needsBulletAdjustment, pixelRatio }) => needsBulletAdjustment && adjustBulletSize({ pixelRatio })}
  
    ${({ needsBulletAdjustment }) => !needsBulletAdjustment && css`
      width: 10px;
      height: 10px;
      margin-top: -5px;
      margin-left: -5px;
    `}

    input:checked ~ & { 
      display: block;
    }

    input:checked:not(:disabled):not([disabled]) ~ & {
      background-color: ${({ theme }) => theme?.RadioButton?.checkedColor || theme.colors.light}; 
    }

    input:checked:disabled ~ &, input:checked[disabled] ~ & {
      background-color: ${({ theme }) => theme.colors.shadowGray2};
    }
  }
`;
